// Hook-заглушка для i18n
export function useTranslation(): (key: string) => string {
    return (key: string) => key;
}
